import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

export default class LockAdminsInput extends Component {
    constructor(p) {
        super(p)

        this.state = {
            admins: [],
            currentInput: ''
        }

        this.addEmail = this.addEmail.bind(this)
        this.removeEmail = this.removeEmail.bind(this)
    }

    addEmail() {
        this.setState({ admins: this.state.admins.concat({ email: this.state.currentInput }), currentInput: '' }, () => this.props.updateAdmins(this.state.admins))
    }

    removeEmail(index) {
        var admins = [...this.state.admins]
        admins.splice(index, 1)
        this.setState({ admins }, () => this.props.updateAdmins(this.state.admins))
    }

    render() {
        return (
            <Grid>
                <Row>
                    <Col xs={6} md={6} lg={6}>
                        <input type="text" onChange={(e) => this.setState({ currentInput: e.target.value })} placeholder="Email-adress" value={this.state.currentInput} className="form-control qlocxInput"></input>
                        <div className="submitUserForm" style={{ fontWeight: 400, width: '100%', fontSize: 'medium', padding: 0, border: 0, marginTop: 20 }} onClick={this.addEmail}>
                            + Lägg till
                        </div>
                    </Col>
                    <Col xs={6} md={6} lg={6}>
                        <div style={{ backgroundColor: 'white', border: '1px solid lightgrey', padding: 10 }}>
                            {this.state.admins.length == 0 ? <p>Inga tillagda administratörer</p> : null}
                            {this.state.admins.map((entry, i) => {
                                return (
                                    <div key={i} style={{ borderBottom: '1px solid lightgrey' }}>
                                        <span>{entry.email}</span> <button onClick={() => this.removeEmail(i)}>X</button>
                                    </div>
                                )
                            })}
                        </div>
                    </Col>
                </Row>
            </Grid>
        )
    }
}

